import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import { FORTA_BLUE, FORTA_GRAY4, FORTA_WHITE } from '../../utils/colors';
import FHTooltip from './FHTooltip';

interface FHCopyToClipboardProps {
  text: string;
  borderColor?: string;
  timeout?: number; // Hide tooltip after timeout
  sx?: any;
}

const tooltipStyle = {
  '& .MuiTooltip-tooltip': {
    borderRadius: '8px',
    boxShadow: '0px 0px 6px 0px rgba(18, 78, 120, 0.25)',
    color: FORTA_GRAY4,
    marginTop: -5,

    '& .MuiTooltip-arrow:before': {
      boxShadow: '0px 0px 6px 0px rgba(18, 78, 120, 0.25)',
    },
  },
};

const textStyle = (borderColor: string) => {
  return {
    textAlign: 'left',
    width: 'fit-content',
    padding: '0 0.2em',
    ml: '-0.2em',
    borderRadius: 10,
    border: `2px solid ${FORTA_WHITE}`,

    '&:hover': {
      border: `2px solid ${borderColor}`,
      zIndex: 1,
    },
    '&.copied:hover': {
      backgroundColor: 'rgba(72, 162, 244, 0.20)',
    },
  };
};

function FHCopyToClipboard(props: FHCopyToClipboardProps) {
  const { text, borderColor = FORTA_BLUE.bright, timeout = 3000, sx } = props;

  const [copied, setCopied] = useState<boolean>(false);

  useEffect(() => {
    if (!copied) return;

    setTimeout(() => {
      setCopied(false);
    }, timeout);
  }, [copied, timeout]);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(
      () => setCopied(true),
      () => setCopied(false),
    );
  };

  return (
    <FHTooltip
      open={copied}
      sx={tooltipStyle}
      title="Copied to clipboard"
      placement="top"
      arrow
      tooltipbackground={FORTA_WHITE}
    >
      <Typography
        sx={{
          ...textStyle(borderColor),
          ...sx,
        }}
        className={copied ? 'copied' : undefined}
        onClick={handleCopy}
        onMouseLeave={() => setCopied(false)}
      >
        {text}
      </Typography>
    </FHTooltip>
  );
}

export default FHCopyToClipboard;
